import { getPrograms, registerAccredited, getAccredited, getAccreditedByCnpj } from '@bforms-web/common';

import AccreditedRegister, { AccreditedRegisterProps } from '../../components/Accredited/register'
const dispatchers: AccreditedRegisterProps = {
  getAccredited,
  registerAccredited,
  getPrograms,
  getAccreditedByCnpj,
};

export default function AccreditedRegisterComposer(): JSX.Element {
  return <AccreditedRegister {...dispatchers} />;
}
